import React, {useState, useEffect} from 'react'
import {Card, Row, Col, Typography, Select, Spin, Divider, Tabs} from 'antd'
import {useGetDashboardData} from 'src/cms/hooks/get/useGetDashboardData'
import styled from 'styled-components'
import {Link} from 'react-router-dom'

const Content = styled.main`
  flex: 1;
  padding: 24px;
`

const Grid = styled.div`
  display: grid;
  grid-gap: 24px;
`

const CardComp = styled.div`
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  overflow: hidden;
`

const CardHeader = styled.div`
  padding: 16px 24px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
`

const CardContent = styled.div`
  padding: 24px;
`
const GridWrapper = styled.div`
  display: grid;
  /* grid-template-columns: repeat(5,1fr); */
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
`
const Label = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
`

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 48px 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 12px;
  border-left: 4px solid;
  border-color: ${(props) => props.color || '#0C4DA1'};
  transition: all 0.3s ease, box-shadow 0.3s ease;
  &:hover {
    background: ${(props) => props.color || '#0C4DA1'};
    color: white;
    * {
      color: white;
    }
  }
`

const StatTitle = styled.div`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
`

const StatValue = styled.div`
  font-size: 24px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${(props) => props.color || 'inherit'};
`

const BranchCard = styled.div`
  /* background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  padding: 16px;
  border-top: 2px solid ${(props) => props.color || '#0C4DA1'}; */
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  padding: 16px;
  border: 1px solid rgb(206, 218, 233);
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
  }
`

const BranchBadge = styled.div`
  min-width: 20px;
  height: 20px;
  border-radius: 10px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  font-size: 12px;
  background-color: ${(props) => props.color || '#0C4DA1'};
`

const BranchTitle = styled.h3`
  margin: 12px 0 0 0;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  justify-content: space-between;
`

const BranchStats = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  margin-top: 16px;
  background: rgb(248, 250, 252);
  padding: 16px;
  border-radius: 8px;
`

const BranchStat = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const StatLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
`

const Icon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

const CardComponent = () => {
  const {TabPane} = Tabs
  const [moduleName, setModuleName] = useState('NewCIFNewAccount')
  const {data: DashboardData, isLoading, error} = useGetDashboardData(moduleName)
  // const [overviewData, setOverviewData] = useState<any>([])
  // console.log(overviewData,"over")
  const [detailsData, setDetailsData] = useState<any>([])
  // console.log(detailsData, 'det')

  useEffect(() => {
    if (DashboardData?.data) {
      const data = DashboardData.data

      // Specific keys to display in the Overview section
      // const overviewKeys = ['total_count', 'total_pending', 'total_completed', 'total_rejected']

      // Prepare dynamic overview data by summing values for the specific keys across all objects
      // const overview = overviewKeys.map((key) => {
      //   let total = 0
      //   Object.keys(data).forEach((objKey) => {
      //     if (data[objKey][key] !== undefined) {
      //       total += data[objKey][key]
      //     }
      //   })

      //   return {
      //     label: key.replace(/_/g, ' ').toUpperCase(),
      //     value: total,
      //   }
      // })

      // setOverviewData(overview)

      // Prepare dynamic details data by checking available fields across all objects
      const details: any = []
      const detailKeys = Object.keys(data[Object.keys(data)[0]]).filter((key) =>
        key.startsWith('total_in')
      )

      detailKeys.forEach((key) => {
        const totals: Record<string, number> = {} // Use Record<string, number> to allow dynamic keys

        Object.keys(data).forEach((objKey) => {
          if (data[objKey][key] !== undefined) {
            totals[objKey] = (totals[objKey] || 0) + data[objKey][key]
          }
        })

        details.push({
          title: key.replace('total_in_', '').replace(/_/g, ' ').toUpperCase(),
          ...totals,
        })
      })

      setDetailsData(details)
    }
  }, [DashboardData])

  const handleModuleChange = (value: string) => {
    setModuleName(value)
  }

  // if (isLoading) {
  //   return (
  //     <div
  //       style={{
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         height: '80vh', // Adjust as needed
  //         width: '100%',
  //       }}
  //     >
  //       <Spin tip='Loading...' size='large' />
  //     </div>
  //   )
  // }

  return (
    <>
      <div>
        <Content>
          <Grid>
            <CardComp>
              <CardContent>
                {/* <Typography.Text strong style={{fontSize: 16}}>
                  Select Module
                </Typography.Text> */}
                <Tabs
                  defaultActiveKey='NewCIFNewAccount'
                  onChange={setModuleName}
                  activeKey={moduleName}
                >
                  <TabPane tab='NewAccountOpening' key='NewCIFNewAccount' />
                  <TabPane tab='NewCIFCreation' key='NewCIF' />
                  {/* <TabPane tab='ExistingCIFNewAccount' key='ExistingCIFNewAccount' />
                  <TabPane tab='UpdateKYC' key='UpdateKYC' /> */}
                </Tabs>
              </CardContent>
            </CardComp>
            {/* Overview */}
            {/* <CardComp>
              <CardHeader>
                <Icon>📊</Icon>
                <span>Overview</span>
              </CardHeader>
              <CardContent>
                <StatsGrid>
                  {overviewData.map((item: any, index: any) => (
                    <StatItem
                      color={`${
                        item.label.includes('TOTAL REJECTED')
                          ? '#ff4d4f'
                          : item.label.includes('TOTAL COMPLETED')
                          ? '#52c41a'
                          : item.label.includes('TOTAL PENDING')
                          ? '#faad14'
                          : '#0C4DA1'
                      }`}
                    >
                      <StatTitle>{item.label}</StatTitle>
                      <StatValue
                        // color="#0C4DA1"
                        color={`${
                          item.label.includes('TOTAL REJECTED')
                            ? '#ff4d4f'
                            : item.label.includes('TOTAL COMPLETED')
                            ? '#52c41a'
                            : item.label.includes('TOTAL PENDING')
                            ? '#faad14'
                            : '#0C4DA1'
                        }`}
                      >
                        {item.label.includes('TOTAL REJECTED') ? (
                          <Icon>❌</Icon>
                        ) : item.label.includes('TOTAL COMPLETED') ? (
                          <Icon>✅</Icon>
                        ) : item.label.includes('TOTAL PENDING') ? (
                          <Icon>⏱️</Icon>
                        ) : (
                          <Icon>📄</Icon>
                        )}

                        {item.value}
                      </StatValue>
                    </StatItem>
                  ))}
                </StatsGrid>
              </CardContent>
            </CardComp> */}
            {/* Branch Details */}
            <CardComp>
              <CardHeader>
                <Icon>📊</Icon>
                <span>Branch Details</span>
              </CardHeader>
              <CardContent>
                <Spin spinning={isLoading} tip='Loading...' size='large'>
                  <GridWrapper>
                    {detailsData.map((item: any, index: any) => (
                      <div key={index}>
                        <BranchCard color='#0C4DA1'>
                          <Link
                            to={{
                              pathname: '/account-list',
                            }}
                            state={{branchData: item.title}}
                          >
                            <BranchTitle>
                              {item.title}
                              <BranchBadge color='#0C4DA1'>
                                {(item.individual || 0) + (item.corporate || 0)}
                              </BranchBadge>
                            </BranchTitle>
                            <BranchStats>
                              {Object.keys(item).map(
                                (key) =>
                                  key !== 'title' && (
                                    <BranchStat key={key}>
                                      <StatLabel>
                                        <Icon>👤</Icon>
                                        {key.replace('_', ' ').toUpperCase()}
                                      </StatLabel>
                                      <strong>{item[key]}</strong>
                                    </BranchStat>
                                  )
                              )}
                            </BranchStats>
                          </Link>
                        </BranchCard>
                      </div>
                    ))}
                  </GridWrapper>
                </Spin>
              </CardContent>
            </CardComp>
          </Grid>
        </Content>
      </div>
    </>
  )
}

export default CardComponent
